import { Component, Input, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { paymentItemMock } from "../../../tests/mocks/payment-item.mock";
import { DownloadReceiptService } from "../../_services/download-receipt.service";

@Component({
  selector: "dev-receipt-mechanism",
  template: `
    <div class="flex flex-col gap-6">
      <button class="button" (click)="getReceipt()">Get receipt</button>
      <div></div>
      <div></div>
      <div></div>
      <payment-result
        (itemSelected)="itemSelected($event, paymentItem)"
        (onShouldReload)="onReload()"
        [(isCollapsed)]="paymentItem.isCollapsed"
        [(itemDetails)]="paymentItem.itemDetails"
        [disableItemSelect]="false"
        [paymentResult]="paymentItem"
      >
      </payment-result>
    </div>
  `,
  styleUrls: ["../../../css/tailwind-utils.scss"],
})
export class DevReceiptMechanismComponent {
  public paymentItem = paymentItemMock;
  public translations$: Observable<ITranslations>;

  constructor(
    private translationService: TranslationService,
    private receiptService: DownloadReceiptService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public itemSelected(selected, item) {}

  public onReload() {}

  public getReceipt() {
    const number = 444053;
    this.receiptService.downloadReceiptByNumber(number).then((r) => r);
  }
}



// WEBPACK FOOTER //
// ./src/app/development/ui/dev-receipt-mechanism.component.ts